// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface MessageUpdate
 */
export interface MessageUpdate {
  /**
   *
   */
  body: string;
}

/**
 * Check if a given object implements the MessageUpdate interface.
 */
export function instanceOfMessageUpdate(value: object): value is MessageUpdate {
  if (!("body" in value) || value["body"] === undefined) return false;
  return true;
}

export function MessageUpdateFromJSON(json: any): MessageUpdate {
  return MessageUpdateFromJSONTyped(json, false);
}

export function MessageUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): MessageUpdate {
  if (json == null) {
    return json;
  }
  return {
    body: json["body"],
  };
}

export function MessageUpdateToJSON(json: any): MessageUpdate {
  return MessageUpdateToJSONTyped(json, false);
}

export function MessageUpdateToJSONTyped(
  value?: MessageUpdate | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    body: value["body"],
  };
}
